import * as React from "react";
const SvgCreative = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M20.223 9.624c.18.678.277 1.39.277 2.126v.5a8.25 8.25 0 0 1-8.25 8.25h-.5a8.25 8.25 0 0 1-8.25-8.25v-.5a8.25 8.25 0 0 1 8.25-8.25h.5c1.447 0 2.806.372 3.988 1.026l.75-1.3A9.706 9.706 0 0 0 12.25 2h-.5C6.365 2 2 6.365 2 11.75v.5C2 17.635 6.365 22 11.75 22h.5c5.385 0 9.75-4.365 9.75-9.75v-.5c0-1.364-.28-2.663-.786-3.842l-.99 1.716Z"
      fill="currentColor"
    />
    <path
      d="M15.864 14.47a1.99 1.99 0 0 0 .87-.805l5-8.66a2 2 0 0 0-3.464-2l-5 8.66a1.99 1.99 0 0 0-.262 1.153 2.544 2.544 0 0 0-1.69 1.222c-.25.433-.361.844-.377 1.249-.015.386.06.734.124 1.012l.024.1c.12.514.213.909.06 1.484a.75.75 0 0 0 .888.925c.182-.041.457-.145.733-.262.294-.126.646-.292 1-.483.353-.19.722-.414 1.044-.655.307-.23.635-.524.835-.87a2.544 2.544 0 0 0 .215-2.07Zm-.429-1.555a.5.5 0 1 1-.866-.5l5-8.66a.5.5 0 1 1 .866.5l-5 8.66ZM14.35 15.79c-.046.08-.178.227-.435.42a7.044 7.044 0 0 1-.856.535c-.117.063-.234.123-.348.18a6.026 6.026 0 0 0-.155-.845l-.028-.118c-.063-.268-.094-.446-.087-.615.006-.151.044-.326.177-.557A1.016 1.016 0 0 1 14 14.397c.467.27.641.889.35 1.393ZM11.75 4.85a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-.5 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM7.5 7.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-.5 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM5.5 14.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCreative;
